<div class="modal-header">
  <h2 class="modal-title">{{ "asset.assetInspection" | translate }}</h2>
  <button type="button"
    class="btn-close"
    aria-label="Close"
    (click)="closeModal()"
  >
  </button>
</div>

<div class="modal-body d-flex flex-column align-items-center">
    <div class="modal-description text-center" [innerHTML]="'asset.inspectionModalDescription' | translate"></div>
    <div class="mobile-app-container ccc d-flex flex-column gap-3">
        <div class="app-provider">
            {{ "Android" }}
        </div>
        <div class="d-flex align-items-center justify-content-between gap-5">
            <div class="qr-box">
                <qrcode [qrdata]="androidLink" [width]="150" [margin]="2"></qrcode>

                <div class="corner top-left"></div>
                <div class="corner top-right"></div>
                <div class="corner bottom-left"></div>
                <div class="corner bottom-right"></div>
            </div>
            <div>
                <a href="{{androidLink}}" target="_blank" rel="noopener noreferrer">
                    <img src="assets/img/global-SVG-assets/google-play.svg" alt ="GooglePlay" />
                </a>
            </div>
        </div>
    </div>
    <div class="mobile-app-container ccc d-flex flex-column gap-3">
        <div class="app-provider">
            {{ "iOS" }}
        </div>
        <div class="d-flex align-items-center justify-content-between gap-5">
            <div class="qr-box">
                <qrcode [qrdata]="iosLink" [width]="150" [margin]="2"></qrcode>

                <div class="corner top-left"></div>
                <div class="corner top-right"></div>
                <div class="corner bottom-left"></div>
                <div class="corner bottom-right"></div>
            </div>
            <div>
                <a href="{{iosLink}}" target="_blank" rel="noopener noreferrer">
                    <img src="assets/img/global-SVG-assets/app-store.svg" alt ="iOS" />
                </a>
            </div>
        </div>
    </div>
</div>

<div class="modal-footer">
  <button class="btn link-btn" (click)="closeModal()">
    {{ "common.closeButton" | translate }}
  </button>
</div>